"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
var _Button = require("../Button/Button");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.workflow .bx--progress {\n  height: 40px;\n  margin-bottom: 1.5rem; }\n  .workflow .bx--progress .bx--progress-step {\n    flex-grow: 1; }\n    .workflow .bx--progress .bx--progress-step .bx--progress-line {\n      width: 100%;\n      border: none;\n      bottom: 0; }\n    .workflow .bx--progress .bx--progress-step.bx--progress-step--current .bx--progress-line, .workflow .bx--progress .bx--progress-step.bx--progress-step--complete .bx--progress-line {\n      height: 2px; }\n    .workflow .bx--progress .bx--progress-step.bx--progress-step--incomplete .bx--progress-line {\n      background-color: #e8e8e8; }\n\n.workflow .workflow-content {\n  min-height: 200px; }\n\n.workflow .workflow-content,\n.workflow .workflow-footer {\n  margin: 0 auto;\n  padding: 0; }\n\n.workflow .workflow-footer {\n  margin-top: 1.5rem;\n  display: flex; }\n  .workflow .workflow-footer button:last-child {\n    margin-left: auto; }\n\n@media (max-width: 671px) {\n  .workflow .bx--progress-step {\n    min-width: initial; }\n    .workflow .bx--progress-step .bx--progress-step-button {\n      justify-content: center; }\n      .workflow .bx--progress-step .bx--progress-step-button svg {\n        margin-right: 0; }\n    .workflow .bx--progress-step .bx--progress-label {\n      display: none; }\n  .workflow .workflow-content .small-only {\n    text-align: center; }\n    .workflow .workflow-content .small-only .position {\n      font-size: 12px;\n      margin-bottom: 16px; }\n    .workflow .workflow-content .small-only .title {\n      font-size: 14px;\n      font-weight: bold;\n      margin-bottom: 1.5rem; } }\n";
  const fileName = "Workflow_Workflow";
  const element = document.querySelector("style[data-sass-component='Workflow_Workflow']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Workflow = props => {
  const slimClasses = props.slimContent ? 'bx--col-lg-6 bx--col-md-4 bx--col-sm-4' : null;
  const currentStep = props.steps[props.currentStepIndex];
  const renderButtons = () => {
    const backButton = props.currentStepIndex > 0 ? /*#__PURE__*/_react.default.createElement(_Button.Button, {
      key: props.labels.back,
      kind: 'secondary',
      onClick: () => props.onNavigate(props.currentStepIndex - 1)
    }, props.labels.back) : null;
    const isLastStep = props.steps.length - 1 === props.currentStepIndex;
    const onClickForwardButton = !isLastStep ? () => props.onNavigate(props.currentStepIndex + 1) : () => props.onSubmit();
    const forwardLabel = !isLastStep ? props.labels.next : props.labels.submit;
    const forwardButton = /*#__PURE__*/_react.default.createElement(_Button.Button, {
      key: forwardLabel,
      onClick: onClickForwardButton
    }, forwardLabel);
    return [backButton, forwardButton];
  };
  const smallOnlyProgressHint = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: 'position'
  }, props.labels.step, " ", props.currentStepIndex + 1, " ", props.labels.of, " ", props.steps.length), /*#__PURE__*/_react.default.createElement("div", {
    className: 'title'
  }, currentStep.label));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'workflow'
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.ProgressIndicator, {
    currentIndex: props.currentStepIndex
  }, props.steps.map((step, index) => /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.ProgressStep, {
    key: step.label,
    label: step.label,
    complete: index < props.currentStepIndex
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: ['workflow-content', slimClasses].join(' ')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'small-only'
  }, smallOnlyProgressHint), currentStep.content), /*#__PURE__*/_react.default.createElement("div", {
    className: ['workflow-footer', slimClasses].join(' ')
  }, renderButtons()));
};
Workflow.propTypes = {
  currentStepIndex: _propTypes.default.number.isRequired,
  onNavigate: _propTypes.default.func.isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  steps: _propTypes.default.array.isRequired,
  labels: _propTypes.default.object.isRequired,
  slimContent: _propTypes.default.bool
};
var _default = exports.default = Workflow;